
import { Vue, Component, Watch } from 'vue-property-decorator'

import { ServerState, ErgState, Erg } from 'shared/state'
import ViewportSize from 'display/ViewportSize'
import { config, GlobalConfig, GlobalTheme, RaceConfig } from 'display/config'
import { displayType } from 'shared/util'
import { version } from '../package.json'
import globalCssVars from './cssVars'

import ServerConnect from 'shared/components/ServerConnect.vue'
import ConfigModal from 'display/components/ConfigModal.vue'
import Wait from 'shared/components/Wait.vue'
import { install } from 'resize-observer'
import { PreRaceState } from 'shared/state'
import type { PreRaceT, WorkoutDataEntry, WorkoutDefinition } from 'shared/types/erg'
import type { RaceDefinition } from 'shared/types/erg'
import { bus } from '../shared/state/Bus'
import RoundAlert from './components/RoundAlert.vue'
import Speech from 'shared/components/Speech.vue'
import DevPanel from 'shared/components/DevPanel.vue'

@Component({ components: { ServerConnect, ConfigModal, Wait, RoundAlert, Speech, DevPanel } })
export default class App extends Vue {

	config = config.vals
	viewport = ViewportSize
	version = version


	@ServerState('state') serverState
	@ErgState() definition
	@ErgState() status
	@GlobalConfig() lang
	// @GlobalConfig() paceraceLockScore
	@GlobalConfig() devMode
	@GlobalConfig() route
	@GlobalConfig() disablePreraceMessages!: boolean
	@PreRaceState() pre_race!: PreRaceT
	@ErgState() current_elimination_round: number
	@RaceConfig() autoScale!: boolean
	@RaceConfig() autoScaleDelay!: number
	@RaceConfig() autoScalePct!: number

	get cssVars() {
		return globalCssVars()
	}

	get isCamera() {
		return this.$route.name?.includes('camera')
	}

	@Watch('route')
	changeRoute() {
		if(this.route && this.$route.name !== this.route) {
			this.$router.push({ name: this.route }).catch(() => {})
		}
	}

	get raceNotLoaded() {
		return	this.$route.name && this.$route.name !== 'home' && (this.definition === null )
	}

	setRemoteId() {
		this.$router.onReady(() => {
			if(this.config.global.remoteId) {
				config.setRemoteId(this.config.global.remoteId, displayType(this.$route.name || undefined))
			}
		})
	}

	get myInnerHeight() {
		// @ts-ignore
		return window.myInnerHeight || 0
	}

created() {
		// @ts-ignore
		if (!window.ResizeObserver) {
			install()
		}
		// fire the resize event at least once upon page load
		const evt = document.createEvent('UIEvents')
		// @ts-ignore
  evt.initUIEvent('resize', true, false, window, 0)
		window.dispatchEvent(evt)
		// pre-load images
		const imgs = ['attention', 'stop', 'go', 'ready']
		for (const i of imgs) {
			const image = new Image()
			image.src = `/assets/img/${i}.svg`
		}
		this.$keybindings.onKeydown(' ', ['Ctrl'], () => this.$root.$emit('toggle-config'))
		Erg.$on('workout_definition', (def: WorkoutDefinition) => {
			if(def !== null && this.$route.name !== 'workout' && !this.$route.name?.includes('cameras')) {
				this.$router.push({ name: 'workout' }).catch(() => {})
			}
		})
		Erg.$on('workout_data', (data: WorkoutDataEntry) => {
			if(data !== null && this.$route.name !== 'workout' && !this.$route.name?.includes('cameras')) {
				this.$router.push({ name: 'workout' }).catch(() => {})
			}
		})
		Erg.$on('race_definition', (def: RaceDefinition) => {
			if(this.$route.name === 'workout'
			&& !this.$route.name?.includes('cameras')
			&& !this.$route.name?.includes('split')
			&& window.history.length > 1) {
				this.$router.go(-1) // Navigate back from workout if there's a previous page (e.g. race, scroll, leaderboard, etc.)
			}
		})

	}
@Watch('pre_race', {immediate: true, deep: true})
	private preraceChanged(newVal) {
	 if(!newVal) { return }
	 if(newVal.id !== null && this.status === 'inactive') {
		Erg.clearDefinition()
	}
	}

}

